import { selectOffer } from './selectOffer';
import { IState } from '../../store';

export const selectIsFutureFlatRepairAfterDeal = (state: IState): boolean => {
  const offer = selectOffer(state);

  return offer?.futureFlatRepairAfterDeal ?? false;
};
